<template>
  <div class="default-layout">
    <header class="default-layout__header">
      <div class="default-layout__header-container">
        <BaseIconButton
          v-if="isSmallerThanTablet"
          icon="menu"
          size="25"
          aria-label="Открыть меню"
          @click="uiStore.toggleIsMenuOpen"
        />
        <RouterLink v-else to="/orders">
          <AppLogo />
        </RouterLink>
      </div>
      <RouterLink v-show="isMobile" to="/orders" class="default-layout__logo-mobile">
        <AppLogo width="76" height="21" />
      </RouterLink>
      <!--DEMO condition-->
      <AppNavBar v-show="$route.name !== 'development'" class="default-layout__nav-bar" />
      <SecondaryButton
        class="prompt-btn"
        :class="{ selected: $route.name === 'aiSettings' }"
        @click="$router.push('/ai-settings')"
        >{{ isSmallerThanTablet ? 'Промпт' : 'Настройка промпта' }}</SecondaryButton
      >
      <BaseIconButton class="default-layout__header-notifications" aria-label="Открыть уведомления">
        <NotificationsIcon active :size="isMobile ? '25' : '27'" />
      </BaseIconButton>
      <ProfileActions />
    </header>
    <div
      class="layout"
      :class="{ show: isSmallerThanTablet ? uiStore.isMenuOpen : false }"
      aria-hidden="true"
      @click="onLayoutClick"
    />
    <main class="default-layout__main">
      <RouterView name="LeftSidebar" class="default-layout__main-sidebar" />
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import AppNavBar from '@/components/AppNavBar.vue'
import NotificationsIcon from '@/components/icon/NotificationsIcon.vue'
import BaseIconButton from '@/components/UI/button/BaseIconButton.vue'
import ProfileActions from '@/components/ProfileActions.vue'
import AppLogo from '@/components/AppLogo.vue'
import SecondaryButton from '@/components/UI/button/SecondaryButton.vue'
import { useScreenStore } from '@/stores/screen'
import { useUIStore } from '@/stores/ui'
import { useFilterStore } from '@/stores/filter'
import { computed, watch } from 'vue'

const screenStore = useScreenStore()
const uiStore = useUIStore()
const filterStore = useFilterStore()

const isScrollLocked = computed(
  () =>
    (isSmallerThanTablet.value && uiStore.isMenuOpen) || uiStore.isPopupOpen || filterStore.isOpen,
)
const isMobile = computed(() => screenStore.isSmallMobile)
const isSmallerThanTablet = computed(() => screenStore.isSmallMobile || screenStore.isMobile)

watch(isScrollLocked, val => {
  if (val) window.document.documentElement.style.overflowY = 'hidden'
  else window.document.documentElement.style.overflowY = 'visible'
})

const onLayoutClick = () => {
  if (uiStore.isMenuOpen) uiStore.toggleIsMenuOpen()
}
</script>

<style scoped lang="scss">
.default-layout {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  :has(.default-layout__main-sidebar) {
    .default-layout__header-container {
      @include tablet {
        position: fixed;
      }
    }
    .default-layout__nav-bar {
      @include tablet {
        margin-left: 290px;
      }
    }
  }

  &.locked {
    overflow-y: hidden;
  }

  &__header {
    height: 47px;
    display: flex;
    padding-right: 16px;
    background-color: $bgGrey;
    border-bottom: 1px solid $borderWhite;

    @include tablet {
      height: 75px;
      padding-right: 50px;
    }

    &-container {
      flex-shrink: 0;
      width: 57px;
      padding: 11px 0 0 16px;
      width: 57px;
      border-right: 1px solid $borderWhite;

      @include tablet {
        padding: 25px 0 25px 50px;
        width: 290px;
        // position: fixed;
        top: 0;
        left: 0;
        background-color: $bgGrey;
      }
    }

    &-notifications {
      margin-right: 16px;

      @include tablet {
        margin-right: 30px;
      }
    }
  }

  &__logo-mobile {
    @include centering;
    margin-left: 12px;
  }

  &__main {
    flex: 1;
    display: flex;
    min-height: 0;

    &-sidebar {
      flex-shrink: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
}

.layout {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: none;
  background-color: #00000033;

  &.show {
    display: block;
  }
}

.prompt-btn {
  max-width: max-content;
  height: 100% !important;
  margin-inline: auto 30px;

  &.selected {
    text-decoration: underline;
    text-underline-offset: 4px;
  }
}
</style>
